export const AUDIT_TRAIL_CHANGE_TYPES = {
  TICKET_CREATED: 'TICKET_CREATED',
  TICKET_CLOSED: 'TICKET_CLOSED',
  TICKET_DEFERRED: 'TICKET_DEFERRED',
  TICKET_ON_HOLD: 'TICKET_ON_HOLD',
  TICKET_STATUS: 'TICKET_STATUS',
  ASSIGNEE: 'ASSIGNEE',
  PRIORITY: 'PRIORITY',
  APPROVAL_STATUS: 'APPROVAL_STATUS',
  ASSET_CHECKED_OUT: 'CHECKOUT_USER',
  ASSET_CHECKED_IN: 'CHECKIN_USER',
  ACCESS_DURATION: 'ACCESS_DURATION',
};

export const AUDIT_TRAIL_BADGE_CLASSES = {
  CREATED: 'badge-created',
  CLOSED: 'badge-closed',
  DEFERRED: 'badge-deferred',
  ON_HOLD: 'badge-on-hold',
  STATUS: 'badge-status',
  ASSIGNEE: 'badge-assignee',
  PRIORITY: 'badge-priority',
  APPROVAL: 'badge-approval',
  CHECKED_OUT: 'badge-checked-out',
  CHECKED_IN: 'badge-checked-in',
  DEFAULT: 'badge-default',
};

export const AUDIT_TRAIL_MESSAGES = {
  WAS_UPDATED: 'was updated',
  TICKET_COMPLETED: 'Ticket Completed',
  TICKET_ON_HOLD: 'Ticket On Hold',
  STATUS_CHANGED_FROM: 'Status changed from',
  TO: 'to',
  TICKET_ASSIGNED_TO: 'Ticket assigned to',
  ASSIGNEE_CHANGED_FROM: 'Assignee changed from',
  PRIORITY_UPDATED: 'Priority updated',
  YESTERDAY: 'Yesterday',
  JUST_NOW: 'Just now',
  UNASSIGNED: 'Unassigned',
  A_TEAM_MEMBER: 'A team member',
  AN_APPROVER: 'An approver',
  CREATED: 'Created',
  ACTIVITY_SUBTITLE: 'There is no activity to show here.',
  SYSTEM: 'System',
  TICKET_MARKED_AS: 'Ticket marked as',
  TICKET_PLACED: 'Ticket placed as',
  APPROVAL_SENT_TO: 'Approval sent to',
  RESENT_REQUEST_TO: 'Resent request to',
  APPROVAL_WAS: 'Approval was',
  TICKET_ACTIVITY: 'Ticket Activity',
  COMMENTS: 'Comments',
  NO_ACTIVITY: 'No Activity Found',
  AUDIT_TRAIL: 'Audit Trail',
  TAB_COMMENTS: 'comments',
  TAB_HISTORY: 'history',
  ASSET_CHECKED_OUT: 'was checked out',
  ASSET_CHECKED_IN: 'was checked in',
  ASSET_CHECK_OUT_DISPLAY: 'Asset checked-out',
  ASSET_CHECK_IN_DISPLAY: 'Asset checked-in',
  ACCESS_DURATION_CHANGED_FROM: 'Access duration changed from',
  DAYS: 'days',
};
